import React from "react";
import { Col } from "react-bootstrap";

import "../stylesheets/DesignExplore.scss";

import arrowdown from "../Assets/arrowdown.svg";
import { Link } from "react-router-dom";

// import { useHistory } from "react-router";
import logo from "../Assets/jiologo.svg";
import logoEnterprise from "../Assets/jiologoenterprise.svg";
import { useEffect } from "react";
import { useState } from "react";
import ConsoleLocalStorage from "../storage/storage";


const Login = (props) => {
  const [org, setOrg] = useState({})
  useEffect(()=>{
    setOrg(ConsoleLocalStorage.getOrganization())
  },[])


  return (
    <React.Fragment>
      <div>
        <div>
          <nav className="navbar navbar-light bg-light ">
            <div className="px-2 container-fluid">
              <Link to="/">
                <img src={org && org.tags && org.tags.toLowerCase()==='enterprise' ? logoEnterprise :logo } alt="logo" className="img-fluid logo" />
              </Link>

              {props.showSignup ? (
                <Link to="/signup" style={{ textDecoration: "none" }}>
                  Sign Up
                </Link>
              ) : null}
            </div>
          </nav>
        </div>
      </div>

      <div class="container-fluid h-100  ">
        <div class="row min-vh-100">
          <div class="col-2" style={{ background: "#1D1D1D" }}>
            <div>
              <Col
                xs={18}
                md={16}
                style={{
                  marginBottom: "10px",
                  borderBottom: "1px solid #3C3C3C",
                }}
              >
                <Link
                  to="/explore/design"
                  style={{
                    color: "white",
                    display: "flex",
                    justifyContent: "space-between",
                    fontFamily: "JioType-Medium",
                    alignItems: "center",
                  }}
                >
                  Design
                  <img
                    src={arrowdown}
                    alt="logo"
                    className="mr-1 fluid logo"
                    style={{
                      width: "0.75rem",
                      height: "0.75rem",
                      marginLeft: "0.25rem",
                      color: "white",
                    }}
                  />
                </Link>
              </Col>

              <Col xs={18} md={16} style={{ marginBottom: "10px" }}>
                <Link
                  to="/explore/develop"
                  style={{
                    color: "white",
                    display: "flex",
                    justifyContent: "space-between",
                    fontFamily: "JioType-Medium",
                    alignItems: "center",
                  }}
                >
                  Develop
                  <img
                    src={arrowdown}
                    alt="logo"
                    className="mr-1 fluid logo"
                    style={{
                      width: "0.75rem",
                      height: "0.75rem",
                      marginLeft: "0.25rem",
                    }}
                  />
                </Link>
              </Col>
            </div>
          </div>

          <div class="col-10" style={{ textAlign: "justify" }}>
            <h1 class="heading mt-4 ml-5">Jio Mixed Reality Design System</h1>
            <h3 class="heading1 mt-2 ml-5">Overview</h3>
            <div class="video ml-5">hello</div>
            <p class="paraexplore ml-5 mt-4">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut
              <br />
              labore et dolore magna aliqua. Ut enim ad minim veniam, quis
              nostrud exercitation ullamco
              <br />
              laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
              dolor in reprehenderit in
            </p>

            <p class="paraexplore1 ml-5 mt-4">
              Voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              Excepteur sint occaecat cupidatat
              <br />
              non proident, sunt in culpa qui officia deserunt mollit anim id
              est laborum.
            </p>
            <div class="col-10" style={{ textAlign: "justify" }}>
              <h1 class="heading mt-4 ml-4">Lorem ipsum dolor</h1>
              <h3 class="heading1 mt-2 ml-4">Overview</h3>
              <div class="video ml-4">hello</div>
              <p class="paraexplore ml-4 mt-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut
                <br />
                labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                nostrud exercitation ullamco
                <br />
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
                dolor in reprehenderit in
              </p>

              <p class="paraexplore1 ml-4 mt-4">
                Voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                Excepteur sint occaecat cupidatat
                <br />
                non proident, sunt in culpa qui officia deserunt mollit anim id
                est laborum.
              </p>
            </div>

            <div class="col-10" style={{ textAlign: "justify" }}>
              <h1 class="heading mt-4 ml-4">Lorem ipsum dolor</h1>
              <h3 class="heading1 mt-2 ml-4">Overview</h3>
              <div class="video ml-4">hello</div>
              <p class="paraexplore ml-4 mt-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut
                <br />
                labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                nostrud exercitation ullamco
                <br />
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
                dolor in reprehenderit in
              </p>

              <p class="paraexplore1 ml-4 mt-4">
                Voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                Excepteur sint occaecat cupidatat
                <br />
                non proident, sunt in culpa qui officia deserunt mollit anim id
                est laborum.
              </p>
              <h2 class="ml-4" style={{ fontSize: "14px", color: "#A0A0A0" }}>
                Show more
              </h2>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
